import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import UseOpenpay from "../../UI/formcard/hooks/openpay";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import AlertTitle from "@mui/material/AlertTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Auth, API, graphqlOperation } from "aws-amplify";
import { getidCard } from "../../../graphql/myQueries";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  profileContainer: {
    marginTop: "5vh",
    minHeight: "90vh",
    padding: "30px 15px",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: 20,
    width: "50%",
    marginLeft: "25%",
    backgroundColor: "#fff",
    borderRadius: "15px",
  },
  info: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "start",
    flexDirection: "column",
    gap: 2,
    backgroundColor: "yellow",
  },
  butonscontainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "30%",
    justifyContent: "center",
    alignItems: "center",
  },
  input: {
    marginBottom: theme.spacing(3),
  },
  inputdate: {
    marginBottom: theme.spacing(3),
    flexDirection: "row",
    display: "flex",
  },
  inputmonth: {
    width: "50%",
  },
  inputYear: {
    marginLeft: "20%",
    width: "30%",
  },
  credit: {
    width: "40%",
  },
  debit: {
    width: "60%",
  },
  inputopp: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  cntbtn: {
    marginTop: "2%",
    width: "50%",
    backgroundColor: "#EA5B13",
  },
  textinfo: {
    fontSize: 13,
  },
  texttitle: {
    fontSize: 16,
    fontWeight: "500",
  },
  cntbtnloading: {
    marginTop: "2%",
    width: "50%",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  alert: {
    position: "relative",
    marginLeft: "60%",
    marginTop: "-5%",
  },
}));

const loadingcircle = styled(CircularProgress)(({ theme }) => ({
  color: "#EA5B13",
  backgroundColor: "#EA5B13",
}));

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#004990",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#EA5B13",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#004990",
    },
    "&:hover fieldset": {
      borderColor: "#004990",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#EA5B13",
    },
  },
  label: { color: "#004990" },
});

const ColorButton = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: "#EA5B13",
  "&:hover": {
    backgroundColor: "#004990",
  },
}));



export default function RegisterCLABE() {

  let redirect = useHistory();
  const classes = useStyles();
  const [openalert, setopenalert] = useState(false);
  const [loading, setloading] = useState(false);
  const { createClient, updatebd, createCLABE } = UseOpenpay();
  const [error, seterror] = useState(false);
  const [idoppbd, setidopp] = useState("");
  const [email, setemail] = useState("");
  const [idSHop, setIdshop] = useState("");
  const [_idopp, _setidopp] = useState("");
  const [availableCard, setavailableCard] = useState(false);
  const [clientfunction, setclientfunction] = useState("");
  const [clabeInput,setClabeInput] = useState("");
  const [User,setUser] = useState("");

  const clabeinfo = {
    clabe: clabeInput,
    alias: "CLABE-SocioComercial-Niku-"+User.substring(0,15),
    holder_name: User,
  };
  
  useEffect(() => {
    if (openalert) {
      setTimeout(() => {
        setopenalert(false);
      }, 2000);
    } else {
      //console.log("no hay alerta");
    }
  }, [openalert]);
  useEffect(() => {
    getUserLoggedIn();
  }, [_idopp != "" ? "" : _setidopp]);

  function createCLABEinter(customerid) {
    createCLABE(customerid, clabeinfo, function (error, clabe) {
      if (error) {
        //console.log("Error al crear la CLABE", error);
        setloading(false);
        seterror(true);
        setopenalert(true);
        setclientfunction(customerid);
        updatebd(customerid, "card", _idopp != null ? _idopp.idcard : "", idSHop, ""); //*Actualizo la BD para que no se vuelva a crear el cliente en opp
      } else {
        setclientfunction("");
        updatebd(customerid, "card", _idopp != null ? _idopp.idcard : "", idSHop, clabe.id);
        setloading(false);
        setopenalert(true);
        redirect.push("/elegir");
      }
    });
  }
  function CreateClient() {
    setloading(true);
    getUserLoggedIn();
    if (idoppbd != "" || clientfunction != "") {
      //*Asignación del json de la bd para buscar la propiedad que ocupemos
      var idclabe = _idopp != null ? _idopp.idclabe : "";
      if (idclabe != "") {
        //*Ya tIene clabe guarada en bd y ya no puede registrar nada
        setavailableCard(true);
        setloading(false);
        seterror(true);
        setopenalert(true);
      } else {
        //*Si el estado de cliente ya va lleno es por que ya lo creo y solo se creara una CLABE
        //CreateCard(clientfunction != "" ? clientfunction : _idopp.openPay_id);
        createCLABEinter(
          clientfunction != "" ? clientfunction : _idopp.openPay_id
        );
      }
    } else {
      createClient(
        {
          name: email,
          email: email,
          requires_account: false,
        },
        function (error, customer) {
          if (error) {
            //console.log("Error al crear el cliente", error);
            setloading(false);
            setopenalert(true);
            seterror(true); //!activo el error para mostrar que no se registro el cliente
          } else {
           // console.log("Cliente creado", customer);
            createCLABEinter(customer.id);
          }
        }
      );
    }
  }
  async function getUserLoggedIn() {
    try {
      const response = await Auth.currentAuthenticatedUser();
    // console.log(response);
      setemail(
        response.attributes.email !== undefined ? response.attributes.email : ""
      );
      setIdshop(
        response.attributes.sub !== undefined ? response.attributes.sub : ""
      );
      const responseOpenpay = await API.graphql(
        graphqlOperation(getidCard, { id: response.attributes.sub })
      );
      var idopenpay = responseOpenpay.data.getAccount.openPay_id;

      _setidopp(JSON.parse(idopenpay));

      setidopp(idopenpay != null && idopenpay != "" ? idopenpay : "");
    } catch (err) {
      console.log("Hubo un error al recuperar al usuario"/* err */);
    }
  }


  return (
    <>
      <div className={classes.profileContainer}>
        <div className={classes.butonscontainer}>
        <div className={classes.input}>
            <CssTextField
            id="outlined-basic"
            label="Nombre completo del titular"
            variant="outlined"
            size="small"
            onChange={(e) => setUser(e.target.value)}
            fullWidth
            type="text"
            maxLength={16}
            />
          </div>
          <div className={classes.input}>
            <CssTextField
            id="outlined-basic"
            label="Ingresa tu CLABE "
            variant="outlined"
            size="small"
            onChange={(e) => setClabeInput(e.target.value)}
            fullWidth
            type="text"
            maxLength={16}
            />
          </div>
          {loading ? (
              <div className={classes.cntbtnloading}>
                <CircularProgress className={loadingcircle} />
              </div>
            ) : (
          <div className={classes.cntbtn}>
            <ColorButton
              variant="contained"
              fullWidth
              onClick={() => CreateClient()}
            >
              Guardar
            </ColorButton>
          </div>
            )}
        </div>
      </div>
      {openalert ? (
        <div className={classes.alert}>
          <Stack
            sx={{ width: "100%", marginTop: "-2%", marginBottom: "1%" }}
            spacing={4}
          >
            {error ? (
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                Instrucción incorrecta —{" "}
                {availableCard ? (
                  <strong>Ya cuentas con una CLABE registrada!</strong>
                ) : (
                  <strong>Valida tus datos!</strong>
                )}
              </Alert>
            ) : (
              <Alert severity="success">
                <AlertTitle>Correcta</AlertTitle>
                Instrucción correcta —{" "}
                <strong>Se ha guardado correctamente!</strong>
              </Alert>
            )}
          </Stack>
        </div>
      ) : null}
    </>
  );
}
